/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { Airport } from '../models/airport';
import { AirportsResponse } from '../models/airports-response';
import { BaseResponse } from '../models/base-response';
import { commonControllerContactBusinessRegistry } from '../fn/common/common-controller-contact-business-registry';
import { CommonControllerContactBusinessRegistry$Params } from '../fn/common/common-controller-contact-business-registry';
import { commonControllerCreateAirport } from '../fn/common/common-controller-create-airport';
import { CommonControllerCreateAirport$Params } from '../fn/common/common-controller-create-airport';
import { commonControllerCreateFlightCompany } from '../fn/common/common-controller-create-flight-company';
import { CommonControllerCreateFlightCompany$Params } from '../fn/common/common-controller-create-flight-company';
import { commonControllerCreateTravelRequest } from '../fn/common/common-controller-create-travel-request';
import { CommonControllerCreateTravelRequest$Params } from '../fn/common/common-controller-create-travel-request';
import { commonControllerDeleteAirport } from '../fn/common/common-controller-delete-airport';
import { CommonControllerDeleteAirport$Params } from '../fn/common/common-controller-delete-airport';
import { commonControllerDeleteFlightCompany } from '../fn/common/common-controller-delete-flight-company';
import { CommonControllerDeleteFlightCompany$Params } from '../fn/common/common-controller-delete-flight-company';
import { commonControllerGetAirports } from '../fn/common/common-controller-get-airports';
import { CommonControllerGetAirports$Params } from '../fn/common/common-controller-get-airports';
import { commonControllerGetFlightCompanies } from '../fn/common/common-controller-get-flight-companies';
import { CommonControllerGetFlightCompanies$Params } from '../fn/common/common-controller-get-flight-companies';
import { commonControllerGetLanguages } from '../fn/common/common-controller-get-languages';
import { CommonControllerGetLanguages$Params } from '../fn/common/common-controller-get-languages';
import { commonControllerSendContactEmail } from '../fn/common/common-controller-send-contact-email';
import { CommonControllerSendContactEmail$Params } from '../fn/common/common-controller-send-contact-email';
import { commonControllerUpdateAirport } from '../fn/common/common-controller-update-airport';
import { CommonControllerUpdateAirport$Params } from '../fn/common/common-controller-update-airport';
import { commonControllerUpdateFlightCompany } from '../fn/common/common-controller-update-flight-company';
import { CommonControllerUpdateFlightCompany$Params } from '../fn/common/common-controller-update-flight-company';
import { FlightCompaniesResponse } from '../models/flight-companies-response';
import { FlightCompany } from '../models/flight-company';
import { LanguagesResponse } from '../models/languages-response';

@Injectable({ providedIn: 'root' })
export class CommonService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `commonControllerGetLanguages()` */
  static readonly CommonControllerGetLanguagesPath = '/common/languages';

  /**
   * Restituisce l'elenco delle lingue.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `commonControllerGetLanguages()` instead.
   *
   * This method doesn't expect any request body.
   */
  commonControllerGetLanguages$Response(params?: CommonControllerGetLanguages$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: LanguagesResponse;
}>> {
    return commonControllerGetLanguages(this.http, this.rootUrl, params, context);
  }

  /**
   * Restituisce l'elenco delle lingue.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `commonControllerGetLanguages$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  commonControllerGetLanguages(params?: CommonControllerGetLanguages$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: LanguagesResponse;
}> {
    return this.commonControllerGetLanguages$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: LanguagesResponse;
}>): BaseResponse & {
'data'?: LanguagesResponse;
} => r.body)
    );
  }

  /** Path part for operation `commonControllerGetAirports()` */
  static readonly CommonControllerGetAirportsPath = '/common/airports';

  /**
   * Restituisce l'elenco degli aeroporti.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `commonControllerGetAirports()` instead.
   *
   * This method doesn't expect any request body.
   */
  commonControllerGetAirports$Response(params?: CommonControllerGetAirports$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: AirportsResponse;
}>> {
    return commonControllerGetAirports(this.http, this.rootUrl, params, context);
  }

  /**
   * Restituisce l'elenco degli aeroporti.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `commonControllerGetAirports$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  commonControllerGetAirports(params?: CommonControllerGetAirports$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: AirportsResponse;
}> {
    return this.commonControllerGetAirports$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: AirportsResponse;
}>): BaseResponse & {
'data'?: AirportsResponse;
} => r.body)
    );
  }

  /** Path part for operation `commonControllerCreateAirport()` */
  static readonly CommonControllerCreateAirportPath = '/common/airports';

  /**
   * Crea un aeroporto.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `commonControllerCreateAirport()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  commonControllerCreateAirport$Response(params: CommonControllerCreateAirport$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: Airport;
}>> {
    return commonControllerCreateAirport(this.http, this.rootUrl, params, context);
  }

  /**
   * Crea un aeroporto.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `commonControllerCreateAirport$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  commonControllerCreateAirport(params: CommonControllerCreateAirport$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: Airport;
}> {
    return this.commonControllerCreateAirport$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: Airport;
}>): BaseResponse & {
'data'?: Airport;
} => r.body)
    );
  }

  /** Path part for operation `commonControllerDeleteAirport()` */
  static readonly CommonControllerDeleteAirportPath = '/common/airports/{code}';

  /**
   * Elimina un aeroporto.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `commonControllerDeleteAirport()` instead.
   *
   * This method doesn't expect any request body.
   */
  commonControllerDeleteAirport$Response(params: CommonControllerDeleteAirport$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: Airport;
}>> {
    return commonControllerDeleteAirport(this.http, this.rootUrl, params, context);
  }

  /**
   * Elimina un aeroporto.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `commonControllerDeleteAirport$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  commonControllerDeleteAirport(params: CommonControllerDeleteAirport$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: Airport;
}> {
    return this.commonControllerDeleteAirport$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: Airport;
}>): BaseResponse & {
'data'?: Airport;
} => r.body)
    );
  }

  /** Path part for operation `commonControllerUpdateAirport()` */
  static readonly CommonControllerUpdateAirportPath = '/common/airports/{code}';

  /**
   * Modifica un aeroporto.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `commonControllerUpdateAirport()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  commonControllerUpdateAirport$Response(params: CommonControllerUpdateAirport$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: Airport;
}>> {
    return commonControllerUpdateAirport(this.http, this.rootUrl, params, context);
  }

  /**
   * Modifica un aeroporto.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `commonControllerUpdateAirport$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  commonControllerUpdateAirport(params: CommonControllerUpdateAirport$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: Airport;
}> {
    return this.commonControllerUpdateAirport$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: Airport;
}>): BaseResponse & {
'data'?: Airport;
} => r.body)
    );
  }

  /** Path part for operation `commonControllerGetFlightCompanies()` */
  static readonly CommonControllerGetFlightCompaniesPath = '/common/flight-companies';

  /**
   * Restituisce l'elenco delle compagnie aeree.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `commonControllerGetFlightCompanies()` instead.
   *
   * This method doesn't expect any request body.
   */
  commonControllerGetFlightCompanies$Response(params?: CommonControllerGetFlightCompanies$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: FlightCompaniesResponse;
}>> {
    return commonControllerGetFlightCompanies(this.http, this.rootUrl, params, context);
  }

  /**
   * Restituisce l'elenco delle compagnie aeree.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `commonControllerGetFlightCompanies$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  commonControllerGetFlightCompanies(params?: CommonControllerGetFlightCompanies$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: FlightCompaniesResponse;
}> {
    return this.commonControllerGetFlightCompanies$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: FlightCompaniesResponse;
}>): BaseResponse & {
'data'?: FlightCompaniesResponse;
} => r.body)
    );
  }

  /** Path part for operation `commonControllerCreateFlightCompany()` */
  static readonly CommonControllerCreateFlightCompanyPath = '/common/flight-companies';

  /**
   * Crea una compagnia aerea.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `commonControllerCreateFlightCompany()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  commonControllerCreateFlightCompany$Response(params: CommonControllerCreateFlightCompany$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: FlightCompany;
}>> {
    return commonControllerCreateFlightCompany(this.http, this.rootUrl, params, context);
  }

  /**
   * Crea una compagnia aerea.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `commonControllerCreateFlightCompany$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  commonControllerCreateFlightCompany(params: CommonControllerCreateFlightCompany$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: FlightCompany;
}> {
    return this.commonControllerCreateFlightCompany$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: FlightCompany;
}>): BaseResponse & {
'data'?: FlightCompany;
} => r.body)
    );
  }

  /** Path part for operation `commonControllerDeleteFlightCompany()` */
  static readonly CommonControllerDeleteFlightCompanyPath = '/common/flight-companies/{code}';

  /**
   * Elimina un aeroporto.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `commonControllerDeleteFlightCompany()` instead.
   *
   * This method doesn't expect any request body.
   */
  commonControllerDeleteFlightCompany$Response(params: CommonControllerDeleteFlightCompany$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: FlightCompany;
}>> {
    return commonControllerDeleteFlightCompany(this.http, this.rootUrl, params, context);
  }

  /**
   * Elimina un aeroporto.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `commonControllerDeleteFlightCompany$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  commonControllerDeleteFlightCompany(params: CommonControllerDeleteFlightCompany$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: FlightCompany;
}> {
    return this.commonControllerDeleteFlightCompany$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: FlightCompany;
}>): BaseResponse & {
'data'?: FlightCompany;
} => r.body)
    );
  }

  /** Path part for operation `commonControllerUpdateFlightCompany()` */
  static readonly CommonControllerUpdateFlightCompanyPath = '/common/flight-companies/{code}';

  /**
   * Modifica una compagnia aerea.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `commonControllerUpdateFlightCompany()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  commonControllerUpdateFlightCompany$Response(params: CommonControllerUpdateFlightCompany$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: FlightCompany;
}>> {
    return commonControllerUpdateFlightCompany(this.http, this.rootUrl, params, context);
  }

  /**
   * Modifica una compagnia aerea.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `commonControllerUpdateFlightCompany$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  commonControllerUpdateFlightCompany(params: CommonControllerUpdateFlightCompany$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: FlightCompany;
}> {
    return this.commonControllerUpdateFlightCompany$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: FlightCompany;
}>): BaseResponse & {
'data'?: FlightCompany;
} => r.body)
    );
  }

  /** Path part for operation `commonControllerCreateTravelRequest()` */
  static readonly CommonControllerCreateTravelRequestPath = '/common/travel-request';

  /**
   * Invia una richiesta di viaggio personalizzato.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `commonControllerCreateTravelRequest()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  commonControllerCreateTravelRequest$Response(params: CommonControllerCreateTravelRequest$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return commonControllerCreateTravelRequest(this.http, this.rootUrl, params, context);
  }

  /**
   * Invia una richiesta di viaggio personalizzato.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `commonControllerCreateTravelRequest$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  commonControllerCreateTravelRequest(params: CommonControllerCreateTravelRequest$Params, context?: HttpContext): Observable<void> {
    return this.commonControllerCreateTravelRequest$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `commonControllerContactBusinessRegistry()` */
  static readonly CommonControllerContactBusinessRegistryPath = '/common/contact-business';

  /**
   * Invia una richiesta dalla business page.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `commonControllerContactBusinessRegistry()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  commonControllerContactBusinessRegistry$Response(params: CommonControllerContactBusinessRegistry$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return commonControllerContactBusinessRegistry(this.http, this.rootUrl, params, context);
  }

  /**
   * Invia una richiesta dalla business page.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `commonControllerContactBusinessRegistry$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  commonControllerContactBusinessRegistry(params: CommonControllerContactBusinessRegistry$Params, context?: HttpContext): Observable<void> {
    return this.commonControllerContactBusinessRegistry$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `commonControllerSendContactEmail()` */
  static readonly CommonControllerSendContactEmailPath = '/common/contact-email';

  /**
   * Invia una Email dal form di contatto.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `commonControllerSendContactEmail()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  commonControllerSendContactEmail$Response(params: CommonControllerSendContactEmail$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return commonControllerSendContactEmail(this.http, this.rootUrl, params, context);
  }

  /**
   * Invia una Email dal form di contatto.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `commonControllerSendContactEmail$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  commonControllerSendContactEmail(params: CommonControllerSendContactEmail$Params, context?: HttpContext): Observable<void> {
    return this.commonControllerSendContactEmail$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
